import { dataStorage } from '@constants';

const storage = typeof window !== 'undefined' ? window[dataStorage] : null;

export const getStorageData = (key) => {
    if (storage) {
        const data = storage.getItem(key);
        try {
            return JSON.parse(data);
        } catch (error) {
            return data;
        }
    }
    return false;
};

export const setStorageData = (key, data) => {
    if (storage) {
        storage.setItem(key, typeof data === 'object' ? JSON.stringify(data) : data);
    }
};

export const removeStorageItem = (key) => {
    if (storage) {
        storage.removeItem(key);
    }
};
